/* import __COLOCATED_TEMPLATE__ from './editable-action-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();